// Module
var code = "<div class=\"universal-image-actions-productize-empty-state\"> <svg-icon src=\"{{ ::$ctrl.svgIcon }}\"></svg-icon> <div class=\"heading\">{{ ::$ctrl.heading }}</div> <div class=\"message\" ng-bind-html=\"::$ctrl.message\"></div> </div> ";
// Exports
module.exports = code;